import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from "@angular/router";
import { inject } from "@angular/core";
import { SitePagesService } from "../site-pages/services/site-pages.service";
import { MOCK_PAGE_1 } from "../mock-data/mock-page-1";
import { CustomPage } from "../../models/page-builder/custom-page.model";

export const getCustomPageResolver: ResolveFn<CustomPage> = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {

  const sitePagesService = inject(SitePagesService);

  const urlParts = state.url.split("/")
  const pageUrl = urlParts[urlParts.length - 1]

  if(["sample-page-2", "sample-page-1"].includes(pageUrl)) {

    return MOCK_PAGE_1
  }

  return await sitePagesService.loadSitePageByUrl(pageUrl)

}
